var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 32,
    viewBox: "0 0 52 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7143 27.7873C22.9907 30.1376 19.4577 31.5565 15.5972 31.5565C6.9831 31.5565 0 24.4923 0 15.7783C0 7.06416 6.9831 0 15.5972 0C19.4577 0 22.9907 1.41886 25.7143 3.76922C28.4379 1.41886 31.9708 0 35.8314 0C44.4455 0 51.4286 7.06416 51.4286 15.7783C51.4286 24.4923 44.4455 31.5565 35.8314 31.5565C31.9708 31.5565 28.4379 30.1376 25.7143 27.7873Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7139 27.7873C29.0675 24.8933 31.194 20.587 31.194 15.7783C31.194 10.9695 29.0675 6.66324 25.7139 3.76922C28.4375 1.41886 31.9704 0 35.831 0C44.4451 0 51.4282 7.06416 51.4282 15.7783C51.4282 24.4923 44.4451 31.5565 35.831 31.5565C31.9704 31.5565 28.4375 30.1376 25.7139 27.7873Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7144 3.76904C29.068 6.66306 31.1944 10.9693 31.1944 15.778C31.1944 20.5867 29.068 24.893 25.7144 27.787C22.3608 24.893 20.2344 20.5867 20.2344 15.778C20.2344 10.9693 22.3608 6.66306 25.7144 3.76904Z",
    fill: "#FF5E00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.10809c87.svg";
export { ForwardRef as ReactComponent };